<template>
  <div>
    <shop-head currentPageName="qpjnh"></shop-head>
    <!-- 面包屑 -->
    <!-- 主要内容 -->
    <div class="content_wrapper">
      <div class="container">
        <!-- <breadcrumb pageName="汽配嘉年华"></breadcrumb> -->
        <el-row :gutter="0">
          <el-col :span="24" :offset="0">
            <div class="head">
              <img
                v-if="activelist[0].image"
                :src="activelist[0].image"
                style="
                  width: 100%;
                  height: 490px;
                  object-fit: fill;
                  position: absolute;
                  top: 0;
                "
              />
              <img
                src="../../assets/images/汽配嘉年华.png"
                alt=""
                style="width: 100%"
              />
              <div class="head-enter">
                <div @click="() => this.$router.push({ name: 'subapply' })">
                  <i class="el-icon-s-custom"></i>{{ $t("展商入口") }} >
                </div>
                <div style="background-color: #16a753">
                  <i class="el-icon-user"> </i> {{ $t("观众入口") }} >
                </div>
                <div style="background-color: #f4f4f4"></div>
              </div>
            </div>
          </el-col>
        </el-row>
        <br />
        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <video
              controls
              src="https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh1fbe7795cfc74c4b9e58ae06eb07c6d5%E5%B9%BF%E5%9B%AD%E6%B1%87.mp4"
              width="500px"
              height="240px"
            ></video>
          </el-col>
          <el-col :span="12" :offset="0">
            <h1 style="color: #1b2d71; font-weight: 600">
              {{ $t("展会概况") }}
            </h1>
            <p>
              {{ activelist[0].content }}
            </p>
            <el-button
              v-if="!detailsVisable"
              type=""
              size="default"
              @click="detailsVisable = true"
              >{{ $t("查看详情") }}></el-button
            >

            <div v-if="detailsVisable">
              <span
                >{{ $t("参加人数") }}: {{ activelist[0].bookingNum
                }}{{ $t("人") }}</span
              >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >{{ $t("活动时间") }}:
                {{ activelist[0].startTime | formatDate }} ~
                {{ activelist[0].endTime | formatDate }}</span
              >
            </div>
          </el-col>
        </el-row>
        <br />
        <h1>{{ $t("观众登记") }}</h1>
        <br />
        <el-form
          :model="form"
          ref="form"
          :rules="rules"
          label-width="150px"
          :inline="false"
          size="normal"
        >
          <el-row :gutter="20">
            <el-col :span="17" :offset="0">
              <el-form-item :label="$t('注册类型') + ':'" prop="companyType">
                <el-radio-group v-model="form.companyType">
                  <el-radio :label="1" border>{{ $t("工厂") }}</el-radio>
                  <el-radio :label="2" border>{{ $t("汽配品牌商") }}</el-radio>
                  <el-radio :label="3" border>{{ $t("维修厂/连锁") }}</el-radio>
                  <el-radio :label="4" border>{{ $t("其他") }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="7" :offset="0">
              <el-form-item prop="companyTypeName" label-width="0px">
                <el-input
                  v-model="form.companyTypeName"
                  :disabled="form.companyType != 4"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="8" :offset="0">
              <el-form-item :label="$t('企业名称') + ':'" prop="companyName">
                <el-input v-model="form.companyName"></el-input> </el-form-item
            ></el-col>
            <el-col :span="8" :offset="0">
              <el-form-item :label="$t('姓名') + ':'" prop="name">
                <el-input v-model="form.name"></el-input> </el-form-item
            ></el-col>
            <el-col :span="8" :offset="0">
              <el-form-item :label="$t('联系电话') + ':'" prop="phone">
                <el-input v-model="form.phone"></el-input> </el-form-item
            ></el-col>
          </el-row>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">{{
              $t("提交申请")
            }}</el-button>
          </el-form-item>
        </el-form>
        <br />
      </div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import shopHead from "../../components/shop/head";
import commonFooter from "../../components/common/footer";
import breadcrumb from "../../components/common/breadcrumb";
import { booking, activelist } from "../../apis/qpjnh";
export default {
  components: {
    shopHead,
    commonFooter,
    breadcrumb,
  },
  filters: {
    formatDate(time) {
      return time ? new Date(time).toLocaleString().replaceAll("/", "-") : "--";
    },
  },
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      detailsVisable: false,
      activelist: [{}],
      form: {
        activityInfoId: "0450b11f62b040289f97f4ad18168475",
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$i18n.t("联系人"),
            trigger: "change",
          },
        ],
        companyType: [
          {
            required: true,
            message: this.$i18n.t("注册类型"),
            trigger: "change",
          },
        ],
        companyName: [
          {
            required: true,
            message: this.$i18n.t("公司名称"),
            trigger: "change",
          },
        ],
        phone: [
          { required: true, message: this.$i18n.t("手机"), trigger: "change" },
        ],
        companyTypeName: [
          {
            required: true,
            message: this.$i18n.t("其他公司类型"),
            trigger: "change",
            validator: (rule, value, callback) => {
              if (this.form.companyType == 4 && !value) {
                callback(new Error(this.$i18n.t("其他公司类型")));
              } else {
                callback();
              }
            },
          },
        ],
      },
      interestedIds: [],
    };
  },
  watch: {
    showDetail(val) {},
  },
  mounted() {
    window.scrollTo(0, 630); // 页面加载后，滚动到300px的位置
  },
  created() {
    this.getList();
  },
  methods: {
    interestedIdsChange(e) {
      this.form.interestedIds = e ? e.join(",") : "";
    },
    async getList() {
      // let list = (await activelist({ status: 2 })).data.list;
      var { list, total } = (await activelist({ status: 2 })).data;
      if (list.length < 1) {
        let data = (await activelist({ status: 3 })).data;
        list = data.list;
        total = data.list;
      }
      this.form.activityInfoId = list[0].id || "";
      this.activelist = list;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          booking(this.form)
            .then((res) => {
              this.$message({
                message: "申请成功!",
                type: "success",
              });
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        } else {
          return false;
        }
      });
    },
    handleChangeSize(value) {
      this.pageSize = value;
      this.search.pageSize = value;
      this.handleSearch();
    },
    handleReset() {
      Object.keys(this.search).forEach((key) => {
        this.search[key] = "";
      });
      this.search.categoryFirstSup = [];
      this.search.manufacturerCname = [];
      this.handleSearch();
    },
    // 查询数据
    handleSearch(currentPage = 1) {
      this.currentPage = currentPage;
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.search,
          currentPage,
        },
      });
      this.productsList({ ...this.search, currentPage });
    },
    /** 跳转详情 */
    gotoDetail(id) {
      this.$router.push({
        path: "/shopDetail",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #fff;

  > h1 {
    color: #1b2d71;
    font-weight: 600;
    border-bottom: #1b2d71 5px solid;
  }

  .head {
    .head-enter {
      position: absolute;
      bottom: 15px;
      left: 0;
      display: flex;
      width: 100%;
      justify-content: space-between;

      div {
        color: #fff;
        line-height: 90px;
        text-align: center;
        cursor: pointer;
        font-size: 20px;
        width: 290px;
        height: 90px;
        background-color: #0f6ab3;
        // border: 1px solid red;
        i {
          font-size: 38px;
          vertical-align: sub;
          margin-top: 10px;
          margin-right: 20px;
        }
      }
    }
  }

  .el-tabs__item {
    height: 65px;
    line-height: 65px;
  }
}
</style>